<template>
  <div id="page-mediaSpec">
    <Row class="main" :gutter="16">
      <Col span="5">
        <div class="aside">
          <h5>预警列表</h5>
          <ul class="taskList">
            <li
              class="taskList-item"
              :class="{'item-selected':item.indexName == now_index_name,'disabled':(!enable_listLong&&index==0)||(!enable_listShort&&index==1)}"
              v-for="(item,index) in taskList"
              :key="index"
              @click="handleSelectTask(item.indexName)"
            >{{item.typeName}}</li>
          </ul>
        </div>
      </Col>
      <Col span="19" id="rightSide">
        <div class="content-up">
          <Row>
            <Col span="3" style="text-align: right">
              <span class="option-title">发布时间</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-date">
                <li
                  class="buttonGroup-item"
                  :class="now_send_time == item.id ? 'buttonGroup-item-selected' : ''"
                  @click="handleSelectLanchDate(item.id)"
                  v-for="(item,index) in sendTimeList"
                  :key="index"
                >{{item.name}}</li>
              </ul>
              <DatePicker
                type="daterange"
                @on-ok="confirmDatePicker"
                @on-clear="clearDatePicker"
                v-model="dateRange"
                placement="bottom-end"
                placeholder="请选择日期范围"
                style="width: 230px"
                confirm
                class="datePicker"
                v-show="isShowDatePicker"
                size="large"
                split-panels
              ></DatePicker>
            </Col>
          </Row>
          <Row class="chose-time" v-if="is_today">
            <Col span="3" style="text-align: right">
              <span class="option-title">时间选择</span>
            </Col>
            <Col span="21" style="text-align:left">
              <TimePicker
                confirm
                size="large"
                format="HH:mm"
                type="timerange"
                placement="bottom-end"
                placeholder="请选择开始结束时间"
                style="width: 230px"
                @on-ok="get_confirm"
                @on-clear="get_clear"
                v-model="timeRange"
              ></TimePicker>
            </Col>
          </Row>
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">结果内搜索</span>
            </Col>
            <Col span="21" style="text-align:left">
              <Input
                v-model="queryData.keyWords"
                search
                @on-search="getMessageListInfo(now_index_name)"
                icon="ios-search-outline"
                placeholder="请输入关键词"
                style="width: 230px"
                class="input-search"
              />
            </Col>
          </Row>
        </div>
        <!-- 舆情列表----------------------------------------------------------------------------->
        <div class="content-down">
          <div class="total-num">
            符合条件的预警信息总共
            <span>{{listMessage_totalNum}}</span>条
          </div>
          <div class="tab-content">
            <div class="listMessage-wrapper">
              <ul class="listMessage">
                <li
                  class="listMessage-item"
                  v-for="(item,index) in contentList"
                  :key="index"
                  @click="go_to_details(item)"
                >
                  <div class="title-wrap" :class="item.warningStatus == 1 ? '' : 'un-send'">
                    <div>{{item.title}}</div>
                    <div></div>
                  </div>
                  <div class="content-wrap">{{item.content=="null"?"":item.content}}</div>
                  <div class="send-detail">
                    <div class="send-source" v-if="item.sourceFrom">来源：{{item.sourceFrom}}</div>
                    <div class="send-time">发布时间：{{item.publishTime}}</div>
                    <div class="send-jobName">所属任务：{{item.jobName}}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="page-wrapper" v-show="isShowPage">
            <Page
              :total="listMessage_totalNum"
              :current="queryData.pageNum"
              :page-size="20"
              @on-change="changePage"
              show-total
            />
          </div>
        </div>
      </Col>
    </Row>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading :isLoading="is_loading"></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_today: true,
      timeRange: [],
      now_index_name: "long",
      now_send_time: "1d",
      sendTimeList: [
        {
          name: "今天",
          id: "1d"
        },
        {
          name: "近3天",
          id: "3d"
        },
        {
          name: "近7天",
          id: "7d"
        },
        {
          name: "近30天",
          id: "30d"
        },
        {
          name: "自定义",
          id: "custom"
        }
      ],
      //任务列表数据
      taskList: [],
      //控制统计数据的加载
      isLoading_statistics: false,
      //传给按照条件查询的数据
      queryData: {
        indexName: "long",
        startTime: null,
        endTime: null,
        pageNum: 1,
        keyWords: ""
      },
      //控制datePiker的显示
      isShowDatePicker: false,
      //datePicker绑定的值
      dateRange: [],
      currentPage: 2,
      listMessage_totalNum: 1,
      contentList: [],
      is_loading: false,
      //如果消息数目为0，则不显示分页
      isShowPage: true,
      //权限-媒体消息列表
      enable_listLong: false,
      //权限-群组消息列表
      enable_listShort: false,
      currentType:null,
    };
  },
  created() {},
  mounted() {
    //获取任务列表数据
    this.getTaskListInfo();
    this.init_data();
    this.getMessageListInfo();
    //获取媒体/群组消息查看权限
    this.getAuthorities();
  },
  methods: {
    //获取媒体/群组消息查看权限
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      //权限-媒体消息
      this.enable_listLong = authorites.includes("warn_list_long");
      //权限-群组消息
      this.enable_listShort = authorites.includes("warn_list_short");
    },
    get_confirm() {
      let that = this;
      if (that.timeRange.length == 0) {
        return;
      }
      that.timeRange[0] = that.getTodayDate() + " " + that.timeRange[0];
      that.timeRange[1] = that.getTodayDate() + " " + that.timeRange[1];
      that.queryData.startTime = new Date(that.timeRange[0]).getTime();
      that.queryData.endTime = new Date(that.timeRange[1]).getTime();
      that.getMessageListInfo(that.currentType);
    },
    get_clear() {
      this.init_data();
      this.getMessageListInfo(this.currentType);
    },
    confirmDatePicker() {
      //校验当前日期范围跨度是否大于30天
      let that = this;
      if (that.dateRange.length == 0) {
        return;
      }
      let differ =
        (new Date(that.dateRange[1]).getTime() -
          new Date(that.dateRange[0]).getTime()) /
          (1000 * 60 * 60 * 24) +
        1;
      if (differ > 30) {
        that.$Message.error("日期范围跨度不得大于30天");
        that.dateRange = []; //清空已选日期
      } else {
        that.queryData.pageNum = 1;
        that.queryData.startTime = new Date(that.dateRange[0]).getTime();
        that.queryData.endTime = new Date(that.dateRange[1]).getTime();
        that.getMessageListInfo(that.currentType);
      }
    },
    clearDatePicker() {
      let that = this;
      that.dateRange = [];
      that.queryData.startTime = null;
      that.queryData.endTime = null;
    },
    getTodayDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    //切换<任务列表>中的项
    handleSelectTask(type) {
      this.currentType = type;
      if (type == "long") {
        //媒体消息
        if (!this.enable_listLong) {
          this.$Message.error("尚未获得该模块权限");
          return;
        }
        
      } else {
        //群组消息
        if (!this.enable_listShort) {
          this.$Message.error("尚未获得该模块权限");
          return;
        }
      }
      let that = this;
      that.now_index_name = type;
      that.init_data();
      that.getMessageListInfo(type);
    },

    //获取任务列表数据
    getTaskListInfo() {
      this.$ajax({
        method: "get",
        url: "./warnlist/list"
      })
        .then(res => {
          res = res.data;
          if (res.success) {
            this.taskList = res.data;
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
          this.$Message.error(err);
        });
    },

    //根据过滤条件获取舆情列表的数据
    getMessageListInfo(type) {
      let that = this;
      that.is_loading = true;
      let listType = "";
      if (type) {
        that.queryData.indexName = type;
      }
      if (type == "long" || !type) {
        //如果不传type或type为长文本
        listType = "Long";
      } else {
        //如果type为短文本
        listType = "Short";
      }
      that
        .$ajax({
          method: "get",
          url: `./warnlist/warnList${listType}`,
          params: that.queryData
        })
        .then(res => {
          res = res.data;
          that.is_loading = false;
          if (res.success) {
            that.contentList = res.data.data;
            this.isShowPage = that.contentList.length > 0 ? true : false;
            that.listMessage_totalNum = res.data.warnListDataSize;
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
          this.$nextTick(() => {
            let rightSideHeight = window.getComputedStyle(
              document.getElementById("rightSide")
            ).height;
            $(".aside").css({
              "min-height": rightSideHeight
            });
          });
        })
        .catch(err => {
          console.log(err);
          that.$Message.error(err);
        });
    },

    // 初始化数据
    init_data() {
      this.queryData.startTime = new Date().setHours(0, 0, 0, 0);
      this.queryData.endTime = new Date().getTime();
      this.queryData.pageNum = 1;
      this.queryData.keyWords = "";
      this.now_send_time = "1d";
      this.is_today = true;
      this.isShowDatePicker = false;
      this.dateRange = [];
      this.currentPage = 1;
    },

    //切换<发布时间>tab
    handleSelectLanchDate(id) {
      let that = this;
      that.now_send_time = id;
      if (id == "1d") {
        that.dateRange = [];
        that.init_data();
      } else if (id == "custom") {
        that.isShowDatePicker = true;
        that.is_today = false;
        that.timeRange = [];
        that.queryData.startTime = null;
        that.queryData.endTime = null;
        that.currentPage = 1;
        return;
      } else {
        that.currentPage = 1;
        this.queryData.pageNum = 1;
        that.dateRange = [];
        that.timeRange = [];
        that.is_today = false;
        that.isShowDatePicker = false;
        that.queryData.startTime =
          new Date().setHours(0, 0, 0, 0) -
          1000 * 60 * 60 * 24 * (parseInt(id) - 1);
        that.queryData.endTime = new Date().getTime();
      }
      that.getMessageListInfo(that.currentType);
    },

    //翻页
    changePage(page) {
      this.queryData.pageNum = page;
      this.getMessageListInfo(this.currentType);
    },

    go_to_details(item) {
      if(item.search_type == '公众号'){
        let date = new Date();
        let nowTime = date.getTime();
        if(nowTime - parseInt(item.update_time) > 6*60*60*1000){
        console.log('guoqi')

          window.open('./wechat?id=' + item.urlid)
        }else{
          window.open(item.sourceUrl);
        }
      }else if(item.sourceUrl){
        window.open(item.sourceUrl);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.flex(@align-items:center,@justify-content:center) {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: @align-items;
  justify-content: @justify-content;
  -webkit-align-items: @align-items;
  -webkit-justify-content: @justify-content;
}

#page-mediaSpec {
  ul {
    list-style-type: none;
  }
  .main {
    width: 1160px;
    margin: 20px auto !important;
    .aside {
      background-color: #fff;
      padding: 35px 0;
      h5 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #333333;
        letter-spacing: -0.41px;
        text-align: left;
        padding-left: 30px;
      }
      .taskList {
        margin-top: 20px;
        .taskList-item {
          height: 47px;
          line-height: 47px;
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #333333;
          letter-spacing: -0.37px;
          text-align: left;
          padding-left: 30px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          &.item-selected {
            background-color: rgb(214, 217, 247);
            color: #415af6;
          }
          &.disabled {
            background-color: #fff;
            color: #999;
            cursor: not-allowed;
          }
        }
      }
    }
    #rightSide {
      .content-up {
        background-color: #fff;
        padding: 30px 20px 48px 20px;
        width: 944px;
        .option-title {
          line-height: 35px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #666666;
          letter-spacing: -0.33px;
          margin-right: 25px;
        }
        .buttonGroup-item {
          float: left;
          line-height: 38px;
          border: 1px solid #ddd;
          height: 40px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
          letter-spacing: -0.29px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          user-select: none;
        }
        .btn-disabled {
          color: #ccc;
          cursor: not-allowed;
        }
        .buttonGroup-item:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
        .buttonGroup-item:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
        .buttonGroup-item-selected {
          background-color: #415af6;
          color: #fff;
        }
        //发布时间----------------------------//
        .buttonGroup-date {
          .buttonGroup-item {
            width: 103px;
          }
          .buttonGroup-item:first-child {
            width: 96px;
          }
        }
        .chose-time {
          margin-top: 24px;
        }
      }
      .content-down {
        background-color: #fff;
        margin-top: 0px;
        padding: 0 23px 50px 46px;
        width: 944px;
        box-sizing: border-box;
        .total-num {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #999999;
          letter-spacing: 0;
          text-align: left;
          border-bottom: 1px solid #efeff4;
          padding-bottom: 16px;
          span {
            color: red;
          }
        }
        .tab-content {
          .tip {
            margin: 20px 0 10px 0;
            p {
              padding-left: 5px;
              height: 30px;
              line-height: 30px;
              text-align: left;
              background-color: #fffcdd;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #ffa810;
              cursor: pointer;
            }
            p:hover {
              opacity: 0.8;
            }
          }
          .listMessage-wrapper {
            margin-top: 16px;
            .listMessage {
              .listMessage-item {
                margin-bottom: 0px;
                cursor: pointer;
                .title-wrap {
                  .flex(center, flex-start);
                  div {
                    &:first-child {
                      font-family: PingFangSC-Medium;
                      font-size: 16px;
                      color: #415af6;
                      letter-spacing: 0;
                      line-height: 24px;
                    }
                    &:last-child {
                      margin-left: 16px;
                      background-image: url("https://static.rong360.com/upload/png/a8/d6/a8d63bd5f28f91f0e6194522d9dd81cf.png");
                      background-repeat: no-repeat;
                      background-size: 69px auto;
                      width: 69px;
                      height: 20px;
                    }
                  }
                }
                .content-wrap {
                  padding-top: 6px;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #666666;
                  letter-spacing: 0;
                  text-align: justify;
                  line-height: 22px;
                }
                .send-detail {
                  font-family: PingFangSC-Regular;
                  font-size: 12px;
                  color: #c8c7cc;
                  letter-spacing: 0;
                  line-height: 14px;
                  padding-bottom: 14px;
                  display: flex;
                  text-align: left;
                  // justify-content: space-between;
                  margin-top: 10px;
                  .send-source {
                    color: #c8c7cc;
                    flex: 1 0 0px;
                  }
                  .send-time {
                    color: #c8c7cc;
                    flex: 1 0 0px;
                  }
                  .send-jobName {
                    color: #c8c7cc;
                    flex: 1 0 0px;
                  }
                }
              }
            }
          }
        }
        .page-wrapper {
          margin-top: 40px;
        }
      }
    }
  }
}
//未发送
.un-send {
  div {
    &:last-child {
      background-image: url("https://static.rong360.com/upload/png/eb/ea/ebea061f8cecedf938ba7481922f700c.png") !important;
    }
  }
}
</style>
